module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand21-5fdc91dbdb90695395e0dc6c4579d938.jpg";